import { Feature, type FeatureType } from "src/states/ApplicationState";

export type ServitutRedegoerelsePhase = "A" | "B";

export function canUseServitutRedegoerelse(
   hasAccessToFeature: (feature: FeatureType) => boolean,
): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelse);
}

export function canUsePhaseA(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return canUseServitutRedegoerelse(hasAccessToFeature);
}

export function canUsePhaseB(hasAccessToFeature: (feature: FeatureType) => boolean): boolean {
   return hasAccessToFeature(Feature.ServitutRedegoerelseB);
}
